import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import { connect } from 'react-redux';

import queryString from 'query-string';

import CompanyOverviewCard from './CompanyOverviewCard';
import UsersCard from './UsersCard';
import RolesCard from './RolesCard';
import CommunicationsCard from './CommunicationsCard';
import UsersPage from './UsersPage';
import RolesPage from './RolesPage';
import AdvancedCommunications from './AdvancedComms/AdvancedCommunications';
import ScoringCard from './ScoringCard';
import ScoringPage from './ScoringPage';

import UnauthorizedPage from '../Global/UnauthorizedPage';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import k2aBaseApi from '../../apis/key2act';
import awsHeader from '../../helpers/awsAuth';

import classes from './Admin.module.css';

import * as ClientActions from '../../actions/clientActions';
import * as CommunicationActions from '../../actions/communicationActions';

class Admin extends Component {
    state = {
        createBillingModalOpen: false,
        companyId:              null,
        users:                  []
    }

    async componentDidMount() {
        let { currentScopes } = this.props;
        this.hasBillingContact();

        if (currentScopes) {
            const queryValues = queryString.parse(this.props.history.location.search);

            if (queryValues.company && isAllowed(currentScopes, Permissions('adminRead'))) {
                this.getUsers(queryValues.company);
            }

            if (queryValues.company && isAllowed(currentScopes, Permissions('adminRead'))) {
                await this.props.fetchInitialClients(queryValues.company);
                // await this.props.fetchClientSettingsEnabledComms(); 
            }

            this.setState(state => ({    
                companyId: queryValues.company
            }));
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        let { currentScopes, companyInfo } = this.props;
        let { companyId } = this.state;

        if (prevProps.currentScopes !== currentScopes || prevState.companyId !== companyId) {
            let companyId = companyInfo.companyId || this.state.companyId;

            if (isAllowed(currentScopes, Permissions('adminRead'))) {
                this.getUsers(companyId);
            }

            if (isAllowed(currentScopes, Permissions('adminRead'))) {
                await this.props.fetchInitialClients(companyId);
                // await this.props.fetchClientSettingsEnabledComms();
            }
        }

        if (companyInfo.billingContact && companyInfo.billingContact.name === '') {
            if (!this.state.createBillingModalOpen) {
                this.setState({
                    createBillingModalOpen: true
                });
            }
        } else {
            if (this.state.createBillingModalOpen) {
                this.setState({
                    createBillingModalOpen: false
                });
            }
        }
    }

    handleCloseModal = () => {
        this.setState(state => ({
            createBillingModalOpen: false
        }));
    }

    handleCreateModal = () => {
        this.setState(state => ({
            createBillingModalOpen: true
        }));
    }

    hasBillingContact = () => {
        let { companyInfo } = this.props;

        if (companyInfo.billingContact != null) {
            let hasBillingContact = companyInfo.billingContact.name !== '';

            this.setState({
                createBillingModalOpen: !hasBillingContact
            });
        }
    }

    getUsers = async companyId => {
        let users;

        try {
            let currentCompany = JSON.parse(sessionStorage.getItem(companyId));

            if (currentCompany) {
                if (currentCompany.users) {
                    users = currentCompany.users;
                } else {
                    users = await this.prepareUsers(companyId);

                    let newCompanyCacheStr = JSON.stringify({
                        ...currentCompany,
                        users
                    });

                    sessionStorage.setItem(companyId, newCompanyCacheStr);
                }
            } else {
                users = await this.prepareUsers(companyId);

                let newCompanyCacheStr = JSON.stringify({
                    users
                });

                sessionStorage.setItem(companyId, newCompanyCacheStr);
            }

            this.setState({ users });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('error caught: ', error);
        }
    }

    getClientCount = () => {
        const { clientSettingsEnabledComms } = this.props;
        const filteredClients = [];

        for (let client in clientSettingsEnabledComms) {
            if (clientSettingsEnabledComms[client].clientEnabled === true) {
                filteredClients.push(client);
            }
        }

        return filteredClients.length;
    }

    updateUsers = async companyId => {
        let newCompanyCacheStr, users;

        try {
            let currentCompany = JSON.parse(sessionStorage.getItem(companyId));

            users = await this.prepareUsers(companyId);

            if (currentCompany && currentCompany.users) {
                currentCompany.users = users;

                newCompanyCacheStr = JSON.stringify({
                    ...currentCompany
                });
            } else {
                newCompanyCacheStr = JSON.stringify({
                    ...currentCompany,
                    users
                });
            }

            this.setState({ users });

            sessionStorage.setItem(companyId, newCompanyCacheStr);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('error caught: ', error);
        }
    }

    prepareUsers = async companyId => {
        const header = await awsHeader();
        let companyUsers, invitedUsers, rawCompanyUsers, rawInvitedUsers;

        rawCompanyUsers = await k2aBaseApi.get(`/companies/${companyId}/accounts?limit=1000`, header);
        rawInvitedUsers = await k2aBaseApi.get(`/companies/${companyId}/invitations?limit=1000`, header);

        companyUsers = rawCompanyUsers.data.data.map(user => {
            user.status = 'confirmed';
            return user;
        });

        invitedUsers = rawInvitedUsers.data.data.map(user => {
            user.status = 'invited';
            return user;
        });

        return [...companyUsers, ...invitedUsers];
    }

    render() {
        const { currentScopes, history, clients } = this.props;
        const { users } = this.state;

        return (
            <div className={classes.Admin}>
                <Switch>
                    <Route
                        path="/admin/users/"
                        render={(routeProps) => (
                            <React.Fragment>
                                {
                                    isAllowed(currentScopes, Permissions('adminFull')) &&
                                    <UsersPage
                                        users={users}
                                        updateUsers={this.updateUsers}
                                    />
                                }
                                {
                                    currentScopes.length > 0 &&
                                  !isAllowed(currentScopes, Permissions('adminFull')) &&
                                  <UnauthorizedPage
                                      history={history}
                                  />
                                }
                                {/*{*/}
                                {/*    <CreateBillingAddressModal*/}
                                {/*        close={this.handleCloseModal}*/}
                                {/*        title="Enter Billing Information"*/}
                                {/*        open={this.state.createBillingModalOpen}*/}
                                {/*        companyInfo={companyInfo}*/}
                                {/*    />*/}
                                {/*}*/}
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path="/admin/communications/"
                        render={(routeProps) => (
                            <React.Fragment>
                                {
                                    isAllowed(currentScopes, Permissions('adminFull')) &&
                                    <AdvancedCommunications />
                                }
                                {
                                    currentScopes.length > 0 &&
                                  !isAllowed(currentScopes, Permissions('adminFull')) &&
                                  <UnauthorizedPage
                                      history={history}
                                  />
                                }
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path="/admin/roles/"
                        render={(routeProps) => (
                            <React.Fragment>
                                {
                                    isAllowed(currentScopes, Permissions('adminFull')) &&
                                    <RolesPage />
                                }
                                {
                                    currentScopes.length > 0 &&
                                  !isAllowed(currentScopes, Permissions('adminFull')) &&
                                  <UnauthorizedPage
                                      history={history}
                                  />
                                }
                                {/*{*/}
                                {/*    <CreateBillingAddressModal*/}
                                {/*        close={this.handleCloseModal}*/}
                                {/*        title="Enter Billing Information"*/}
                                {/*        open={this.state.createBillingModalOpen}*/}
                                {/*        companyInfo={companyInfo}*/}
                                {/*    />*/}
                                {/*}*/}
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path="/admin/scoring/"
                        render={(routeProps) => (
                            <React.Fragment>
                                {
                                    isAllowed(currentScopes, Permissions('adminFull')) &&
                                    <ScoringPage props={this.props} />
                                }
                                {
                                    currentScopes.length > 0 &&
                                  !isAllowed(currentScopes, Permissions('adminFull')) &&
                                  <UnauthorizedPage
                                      history={history}
                                  />
                                }
                            </React.Fragment>
                        )}
                    />
                    <Route
                        path="/admin/"
                        render={(routeProps) => (
                            <React.Fragment>
                                <CompanyOverviewCard />
                                {
                                    isAllowed(currentScopes, Permissions('adminRead')) &&
                                    <UsersCard
                                        users={users}
                                    />
                                }
                                {
                                    isAllowed(currentScopes, Permissions('adminRead')) &&
                                    <RolesCard />
                                }
                                {   
                                    process.env.advancedCommEnabled &&
                                    isAllowed(currentScopes, Permissions('adminRead')) &&
                                    <CommunicationsCard
                                        clients={clients}
                                        count={this.getClientCount()}
                                        isLoading={false}
                                    />
                                }
                                {
                                    isAllowed(currentScopes, Permissions('adminRead')) &&
                                    <ScoringCard />
                                }
                                {/*{*/}
                                {/*    (companyInfo.billingContact !== null) &&*/}
                                {/*    isAllowed(currentScopes, Permissions('default')) &&*/}
                                {/*    <BillingCard />*/}
                                {/*}*/}
                                {/*{*/}
                                {/*    <CreateBillingAddressModal*/}
                                {/*        close={this.handleCloseModal}*/}
                                {/*        title="Enter Billing Information"*/}
                                {/*        open={this.state.createBillingModalOpen}*/}
                                {/*        companyInfo={companyInfo}*/}
                                {/*    />*/}
                                {/*}*/}
                            </React.Fragment>
                        )}
                    />
                </Switch>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        companyInfo:                state.companyInfo,
        currentScopes:              state.core.currentScopes,
        clients:                    state.client.clients,
        clientSettings:             state.communications.clientSettings,
        clientSettingsEnabledComms: state.communications.clientSettingsEnabledComms,
        clientSettingsLoading:      state.communications.clientSettingsLoading
        

    };
};

const mapDispatchToProps = {
    ...ClientActions,
    ...CommunicationActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
